"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emptyUserSelection = emptyUserSelection;

function emptyUserSelection() {
  // Shamelessly ripped from https://stackoverflow.com/a/3169849
  if (window.getSelection) {
    var selection = window.getSelection();

    if (selection.empty) {
      selection.empty();
    } else if (selection.removeAllRanges) {
      selection.removeAllRanges();
    }
  } else if (document.selection && document.selection.empty) {
    document.selection.empty();
  }
}